import React, { useState } from "react";
import { ScrollView } from "react-native";
// Components
import Screen from "../components/Screen";
// API
import useApi from "../hooks/useApi";
import productsApi from "../api/products";
// Config
import useProducts from "../hooks/useProducts";
import ListItemTextInput from "../components/lists/ListItemTextInput";
import ListItem from "../components/lists/ListItem";
import IconTouchable from "../components/IconTouchable";
import BlockSeperator from "../components/BlockSeperator";
import LocationPicker from "../components/pickers/LocationPicker";
import CategoryPicker from "../components/pickers/CategoryPicker";
import VehiclePicker from "../components/pickers/VehiclePicker";

function NewProductScreen({ navigation }) {
    const [message, setMessage] = useState(false);

    const [description, setDescription] = useState();
    const [price, setPrice] = useState();
    const [category, setCategory] = useState();
    const [location, setLocation] = useState();
    const [vehicle, setVehicle] = useState();

    const newProductApi = useApi(productsApi.newProduct);
    const { getProducts } = useProducts();

    const handleSubmit = async () => {
        const response = await newProductApi.request(description, price, category, location, vehicle);
        if (response.ok) {
            getProducts();
            navigation.goBack();
        } else {
            setMessage("Unable to add Product");
        }
    };

    return (
        <Screen title={"New Product"} navigation={navigation} setMessage={setMessage} message={message}>
            <ScrollView>
                <ListItemTextInput title={"Price"} onChange={(text) => setPrice(text)} />
                <ListItemTextInput title={"Product Description"} onChange={(text) => setDescription(text)} />
                <CategoryPicker onChange={(category) => setCategory(category)} />
                <LocationPicker onChange={(location) => setLocation(location)} />
                <VehiclePicker onChange={(vehicle) => setVehicle(vehicle)} />
                <BlockSeperator />
                <ListItem title="Add Product" utilityComponent={<IconTouchable name="check" onPress={() => handleSubmit()} />} />
            </ScrollView>
        </Screen>
    );
}

export default NewProductScreen;
